import Marquee from "react-fast-marquee";
import { CONTENT } from "../data/content";

export const MarqueeDivider = () => (
    <div className="border-y border-white/10 py-6 md:py-8" data-testid="marquee-divider">
        <Marquee speed={30} gradient={false} pauseOnHover>
            <span className="font-display text-5xl uppercase tracking-wide md:text-7xl">
                <span className="text-outline">{CONTENT.marquee}</span>
                <span className="text-outline">{CONTENT.marquee}</span>
            </span>
        </Marquee>
    </div>
);
